import { aktuelleRichtung, nativeAntwortReferenz, type RichtungDokument } from './guide-richtung.js';

export interface AntwortwegeRenderBuehne {
  entscheidungen?: readonly {id:string;antwort?:unknown;umgezogen?:unknown;zurueckgezogen?:unknown}[];
  vorschlaege?: readonly {id:string;antwort?:unknown;umgezogen?:unknown;zurueckgezogen?:unknown}[];
  richtung?: RichtungDokument;
  abschluss?:unknown;
}
export interface AntwortwegeRenderZustand {entscheiden:boolean;wartend?:boolean;richtungBedienbar:boolean}
/** Native Guide renderer contract, not a screenshot or a consultant's assertion of visibility.
 * The same selector must be used for rendering and the publication manifest. */
export function angeboteneAntwortwege(b:AntwortwegeRenderBuehne,r:AntwortwegeRenderZustand):Array<{art:'entscheidung'|'vorschlag'|'richtung';id:string}> {
  if(b.abschluss)return [];
  const wege:Array<{art:'entscheidung'|'vorschlag'|'richtung';id:string}>=[];
  if(!r.wartend) {
    if(r.entscheiden) for(const q of b.entscheidungen??[]) if(!q.antwort&&!q.umgezogen&&!q.zurueckgezogen)wege.push({art:'entscheidung',id:q.id});
    for(const q of b.vorschlaege??[]) if(!q.antwort&&!q.umgezogen&&!q.zurueckgezogen)wege.push({art:'vorschlag',id:q.id});
  }
  if(r.richtungBedienbar)for(const q of aktuelleRichtung(b.richtung)?.entwurf.fragen??[])if(!nativeAntwortReferenz(q))wege.push({art:'richtung',id:q.id});
  return wege;
}
